import React, { useState } from "react";
import { Formik, Field, ErrorMessage, Form } from "formik";
import * as Yup from "yup";
import { ModalBody } from "reactstrap";
import CloudStorage from "../../../../CloudStorage/CloudStorage";

const formdatatomap = [
  {
    title: "Choose post type",
    name: "work_location",
    placeholder: "Choose post type",
  },
];

const ModelWorkLocation = ({
  formData,
  setFormData,
  setModalwork_location,
}) => {
  const initialValues = {
    work_location: formData?.work_location || "1", // Set a default value if necessary
  };

  const validationSchema = Yup.object().shape({
    work_location: Yup.string().required("Work location is required"),
  });

  const handleSubmit = (values) => {
    setFormData((prevData) => ({
      ...prevData,
      ...values,
    }));
    setModalwork_location((state) => !state);
  };

  return (
    <>
      <button
        onClick={() => setModalwork_location((state) => !state)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt="Close"
        />
      </button>
      <ModalBody>
        <h4>Choose Location</h4>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {(formik) => (
            <Form>
              {}
              {formdatatomap.map((prop, key) => (
                <div key={key} className="form-group">
                  <h6>{prop.title}</h6>
                  <div className="checkbox-label ">
                    <label className="checkbox-container">
                      <Field
                        type="radio"
                        name={prop.name}
                        value="1"
                        checked={formik.values[prop.name] == 1}
                      />
                      <span className="checkmark">Virtual</span>
                    </label>
                    <label className="checkbox-container">
                      <Field
                        type="radio"
                        name={prop.name}
                        value="2"
                        checked={formik.values[prop.name] == 2}
                      />
                      <span className="checkmark">Physical</span>
                    </label>
                    <ErrorMessage
                      name={prop.name}
                      component="div"
                      className="error"
                    />
                  </div>
                </div>
              ))}
              <div className="modal-footer mt-3">
                <button type="submit" className="btn">
                  Save
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </>
  );
};

export default ModelWorkLocation;
